var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3299 4H3.67014C2.74653 4 2 4.74653 2 5.66667V17.8889C2 18.809 2.74653 19.5556 3.67014 19.5556H20.3299C21.2535 19.5556 22 18.809 22 17.8889V5.66667C22 4.74653 21.2535 4 20.3299 4ZM3.87847 5.66667H20.1215C20.2361 5.66667 20.3299 5.76042 20.3299 5.875V7.33333H3.67014V5.875C3.67014 5.76042 3.76389 5.66667 3.87847 5.66667ZM20.1215 17.8889H3.87847C3.76389 17.8889 3.67014 17.7951 3.67014 17.6806V11.7778H20.3299V17.6806C20.3299 17.7951 20.2361 17.8889 20.1215 17.8889ZM8.66667 14.4167V15.8056C8.66667 16.0347 8.47917 16.2222 8.25 16.2222H5.75C5.52083 16.2222 5.33333 16.0347 5.33333 15.8056V14.4167C5.33333 14.1875 5.52083 14 5.75 14H8.25C8.47917 14 8.66667 14.1875 8.66667 14.4167ZM15.3333 14.4167V15.8056C15.3333 16.0347 15.1458 16.2222 14.9167 16.2222H10.1944C9.96528 16.2222 9.77778 16.0347 9.77778 15.8056V14.4167C9.77778 14.1875 9.96528 14 10.1944 14H14.9167C15.1458 14 15.3333 14.1875 15.3333 14.4167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodCard);
export default __webpack_public_path__ + "static/media/payment-method-card.7c435c2fbb379da91e04a652c9f1cd21.svg";
export { ForwardRef as ReactComponent };